<p class="msg" *ngIf="isEaj">
  所属企業により発行される<label style="color: #bc3131; font-weight: 600;"
    >ID・パスワード</label
  >でログインしてください。
</p>
